
import sideCartMixin from '@marketplace/components/storefront-page/parts/side-cart/sideCartMixin.js'

export default {
    mixins: [sideCartMixin],
}
